// Entry point for the build script in your package.json
console.log("APPLICATION.JS LOADING!");
import "@hotwired/turbo-rails"
import "./controllers"
import React from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App"

console.log("APPLICATION.JS: Modules imported");

document.addEventListener("DOMContentLoaded", () => {
  console.log("APPLICATION.JS: DOMContentLoaded fired");
  const rootElement = document.getElementById("react-root")
  console.log("APPLICATION.JS: rootElement =", rootElement);
  if (rootElement) {
    console.log("APPLICATION.JS: Creating React root");
    const root = createRoot(rootElement)
    console.log("APPLICATION.JS: Rendering App");
    root.render(<App />)
    console.log("APPLICATION.JS: App rendered");
  } else {
    console.error("APPLICATION.JS: No react-root element found!");
  }
})
